import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Box, Button, ShadowBox } from '@components/common';
import { TableHeading } from '@components/Typography';
import { AuthSelectors } from '@redux/AuthRedux';
import PasswordModal from './PasswordModal';
import AccountModal from './AccountModal';
import TableCell from '@components/TableCell';

function AccountInfo(props) {
  const { user } = props;
  const { firstName, lastName, email, phone } = user;
  const [showPassword, togglePassword] = useState(false);
  const [showEdit, toggleEdit] = useState(false);

  return (
    <React.Fragment>
      <Box
        mb={4}
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        width={1}
      >
        <TableHeading>My Apartment</TableHeading>
        <Box display={['none', 'flex']}>
          <Button
            variant="secondary"
            size="small"
            onClick={() => toggleEdit(true)}
          >
            Edit
          </Button>
        </Box>
      </Box>
      <ShadowBox mb={4}>
        <TableCell title="First Name" rightText={firstName} />
        <TableCell title="Last Name" rightText={lastName} />
        <TableCell title="Phone" rightText={phone} />
        <TableCell
          title="Email"
          rightWeighted
          rightTextStyle={{
            wordBreak: 'break-all'
          }}
          rightText={email}
        />
      </ShadowBox>
      <Box
        display={['none', 'flex']}
        flexDirection="row"
        mb={4}
        justifyContent="space-between"
      >
        <Button
          variant="secondary"
          size="small"
          onClick={() => togglePassword(true)}
        >
          Change Password
        </Button>
      </Box>
      <Box display={['flex', 'none']} flexDirection="column" mb={4}>
        <Button variant="secondary" mb={4} onClick={() => toggleEdit(true)}>
          Edit my details
        </Button>
        <Button variant="secondary" onClick={() => togglePassword(true)}>
          Change Password
        </Button>
      </Box>
      <AccountModal show={showEdit} dismiss={() => toggleEdit(false)} />
      <PasswordModal
        show={showPassword}
        dismiss={() => togglePassword(false)}
      />
    </React.Fragment>
  );
}

AccountInfo.propTypes = {
  user: PropTypes.object
};

const mapStatesToProps = state => ({
  user: AuthSelectors.selectCurrentUser(state)
});

export default connect(mapStatesToProps)(AccountInfo);
